export default __webpack_public_path__ + "static/media/madalla-terminal.92fe1640.png";